<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width="16" 
        height="16" 
        :fill="fillColor" 
        :class="svgClass" 
        viewBox="0 0 16 16"
    >
        <path d="M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A2 2 0 0 0 8 6c-.532 0-1.016.208-1.375.547M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>
    </svg>
</template>
  

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['fill', 'iconClass'])

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-5 h-5'
})

const fillColor = computed(() => {
    return props.fill ? props.fill : 'black'
})

</script>